import {
  FontAwesomeIcon,
  FontAwesomeLayers,
} from '@fortawesome/vue-fontawesome';

export const mixinComponents = {
  FontAwesomeIcon,
  FontAwesomeLayers,
};
